import { getCurrentLocalesFor } from '../../../../config/locales.cjs';

/**
 * @param {string} locale
 * @returns {string[]}
 */
mpro.getCurrentLocalesFor = getCurrentLocalesFor;

export default mpro;
